import { Col, Form, Radio, Row } from 'antd';
import Button from '../../../../components/Buttons/Button';
import FormDatePicker from '../../../../components/Inputs/FormDatePicker';
import FormInput from '../../../../components/Inputs/FormInput';
import FormSelectBox from '../../../../components/Inputs/FormSelectBox';
import FormTimePicker from '../../../../components/Inputs/FormTimePicker';
import FormLabel from '../../../../components/Labels/FormLabel';
import HallFiledCard from '../HallFiledCard';

const BidDurationModal = () => {
  const [form] = Form.useForm();

  return (
    <>
      <Form form={form} name="BiddingModalSearchForm" className="p-15">
        <Row gutter={30} className="mt-2 mb-5">
          <Col sm={6}>
            <HallFiledCard containerClass="mb-10 min-height-35" title="Admin Email Address">
              rahimam@nvisionglobal.com
            </HallFiledCard>
          </Col>
        </Row>
        <Row gutter={30}>
          <Col sm={6}>
            <FormLabel>Expiration Time</FormLabel>
            <div className="mb-5">
              <div className="form-item">
                <Radio className="" checked={false}>
                  {/* biome-ignore lint/a11y/noLabelWithoutControl: <explanation> */}
                  <label className="f-13 fw-600">Date & Hours</label>
                </Radio>
              </div>
              <div className="form-item mt-25">
                <Radio className="" checked>
                  {/* biome-ignore lint/a11y/noLabelWithoutControl: <explanation> */}
                  <label className="f-13 fw-600">Date & Time</label>
                </Radio>
              </div>
            </div>
          </Col>

          <Col sm={18}>
            <Row gutter={30}>
              <Col sm={8}>
                <FormDatePicker name="selectDate" label="Select Date" margin="m-0" />
              </Col>
              <Col sm={8}>
                <FormSelectBox name="selectDate" label="Select Hours" margin="m-0" editMode />
              </Col>
              <Col sm={8}>
                <FormInput name="TargetRate" label="Target Rate" margin="m-0" editMode />
              </Col>
            </Row>

            <Row gutter={30} className="mt-5">
              <Col sm={8}>
                <FormDatePicker
                  name="selectDate"
                  label="Select Date"
                  margin="m-0"
                  rules={[{ required: true, message: '' }]}
                />
              </Col>
              <Col sm={8}>
                <FormTimePicker
                  name="selectTime"
                  label="Select Time"
                  margin="m-0"
                  editMode
                  rules={[{ required: true, message: '' }]}
                />
              </Col>
              <Col sm={8}>
                <FormSelectBox
                  name="selectTimeZone"
                  label="Select Time Zone"
                  margin="m-0"
                  editMode
                  rules={[{ required: true, message: '' }]}
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </Form>

      <Row justify="end" align="middle">
        <Col className="px-15 py-5">
          <Row gutter={15}>
            <Col>
              <Button type="primary" variant="success">
                Submit Spot Bid
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default BidDurationModal;
